import {useValidatePath} from "../hooks";

export const useApp = () => {
    // Data validator according to the current path location.
    // Documentation regarding this function can be found within its file.
    const {
        setPathLocation,
        isSpecialPath,
        pathLocation
    } = useValidatePath();

    // Method to handle all the route changes
    const handleRouteChange = url => {
        setPathLocation(url);
    }

    return {
        isSpecialPath,
        pathLocation,
        handleRouteChange
    }
}
